import { IFilter } from "interfaces/filter/IFilter"
import { useFilterStore } from "@/stores/filterStore"
import { useQuery } from "./query-service";
import { useFilterApply } from "./filter-apply-service";
import { useUtil } from "./util-service";

export const useFilterState = () => {
  const filterStore = useFilterStore();
  const { applyFilters } = useFilterApply();
  const { updateQueryParameters } = useQuery();
  const { arraysContainTheSameValues } = useUtil();

  const setFilters = (filters: IFilter[]) => {
    filterStore.activeFilters = filters.filter((f: IFilter) => f.dataKey !== 'search');
    filterStore.activeSearchFilters = filters.filter((f: IFilter) => f.dataKey === 'search');
  }

  const addSearchFilter = (filterQuery: string) => {
    filterStore.activeSearchFilters.push(filterQuery);
    applyFilters();
  }

  const removeSearchFilter = (filterQuery: string) => {
    const currentFilterIndex = filterStore.activeSearchFilters.findIndex((filter: string) => filter === filterQuery);
    if (currentFilterIndex !== -1) {
      filterStore.activeSearchFilters.splice(currentFilterIndex, 1);
      applyFilters();
    }
  }

  const updateFilter = (filter: IFilter) => {
    const isEmpty = Array.isArray(filter.value) ? filter.value.length === 0 : filter.value === '';
    const currentFilterIndex = filterStore.activeFilters.findIndex((f: IFilter) =>
      f.dataKey === filter.dataKey || arraysContainTheSameValues(f.dataKey as string[], filter.dataKey as string[]));

    if (isEmpty) {
      if (currentFilterIndex !== -1) {
        filterStore.activeFilters.splice(currentFilterIndex, 1);
       applyFiltersAndUpdateQuery(filter);
      }
      return;
    }

    if (currentFilterIndex !== -1) {
      // A filter with this dataKey already exists, update it
      filterStore.activeFilters[currentFilterIndex].value = filter.value
    } 
    else {
      // Just push it in
      filterStore.activeFilters.push(filter)
    }
    applyFiltersAndUpdateQuery(filter);
  }

  const applyFiltersAndUpdateQuery = (filter: IFilter) => {
    updateQueryParameters(filter);
    applyFilters();
  }

  return {
    setFilters,
    updateFilter,
    addSearchFilter,
    removeSearchFilter
  }
}